/**
 * Display labels for e-invoice statuses.
 *
 */
export const invoiceStatusLabels: Record<string, string> = {
  Submitting: "Submitting…",
  PendingCheck: "Syncing",
  DuplicateConflict: "Needs review",
};

/** Falls back to the raw status so a new backend status is never hidden. */
export const getInvoiceStatusLabel = (status: string): string =>
  invoiceStatusLabels[status] ?? status;
